import React, { useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import WindowEventHelper from '../../lib/WindowEventHelper';
import { isDescendant } from '../../lib/DomUtils';
import { closeMyInfoLayer } from '../../actions';

function UserInfo () {
  const { user } = Config;
  const { memberUrl } = appInfo;
  return (
    <div className="info_profile">
      <a href={memberUrl} className="txt_id txt_id_type2">{user.name}</a>
      <span className="txt_email">{user.loginId}</span>
      <a href={memberUrl} className="link_setting link_setting_type2">계정관리</a>
    </div>
  );
}


function BlogItem ({ blog }) {
  return (
    <div key={blog.id} className="info_profile info_profile_type1">
      <a href={blog.defaultUrl} className="txt_id">{blog.title}</a>
      <a href={`${blog.adminUrl}/post`} className="img_common_tistory link_edit">쓰기</a>
      <a href={blog.adminUrl} className="img_common_tistory link_setting">블로그 관리</a>
    </div>
  );
}

function BlogList () {
  const { blogs, useBlogList } = Config;
  if (!useBlogList) {
    return null;
  }

  const { ownerBlogs, memberBlogs } = blogs;
  return (
    <div className="wrap_list #blogList" style={{ maxHeight: '300px' }}>
      <div>
        <h3 className="tit_list_type">운영중인 블로그</h3>
        {ownerBlogs.map(blog => <BlogItem key={blog.id} blog={blog} />
        )}
      </div>

      {memberBlogs.length > 0 &&
        <div>
          <h3 className="tit_list_type">참여중인 블로그</h3>
          {memberBlogs.map(blog => <BlogItem key={blog.id} blog={blog} />
          )}
        </div>
      }
    </div>
  );
}


export default function () {
  const dispatch = useDispatch();
  const root = useRef(null);

  function handleCloseMyInfoLayer () {
    dispatch(closeMyInfoLayer());
  }

  useEffect(() => {
    WindowEventHelper.add('click', handleToggle);
    return () => {
      WindowEventHelper.remove('click', handleToggle);
    };
  }, []);

  function handleToggle (e) {
    if (!isDescendant(root.current, e.target)) {
      e.preventDefault();
      handleCloseMyInfoLayer();
    }
  }

  function handleLogout () {
    document.location.href = appInfo.logoutUrl;
  }

  return (
    <div ref={root} className="header_layer layer_profile #sideToolBar">
      <div className="inner_header_layer"><h2 className="screen_out">개인정보</h2>
        <UserInfo />
        <BlogList />
        <button className="btn_logout" onClick={handleLogout}>로그아웃</button>
      </div>
    </div>
  );
}
